export enum ParkingRequestTypeIdConstant {
  STORAGE = 1,
  RETRIEVAL = 2,
  BOOKING = 3,
  CANCEL_STORAGE = 4,
  CANCEL_RETRIEVAL = 5,
  CANCEL_BOOKING = 6
}

export enum ParkingRequestTypeConstant {
  STORAGE = "Storage",
  RETRIEVAL = "Retrieval",
  BOOKING = "Booking",
  CANCEL_STORAGE = "Cancel_Storage",
  CANCEL_RETRIEVAL = "Cancel_Retrieval",
  CANCEL_BOOKING = "Cancel_Booking"
}

/* define in Parking Status Master Values*/
export enum ParkingStatusConstant {
  EXECUTION = "Execution",
  WAITING = "Waiting",
  PARKED = "PARKED",
  RETRIEVED = "RETRIEVED",
  REJECTED = "REJECTED"
}

export const ParkingRequestTypeMap: Record<ParkingRequestTypeConstant, ParkingRequestTypeIdConstant> = {
  [ParkingRequestTypeConstant.STORAGE]: ParkingRequestTypeIdConstant.STORAGE,
  [ParkingRequestTypeConstant.RETRIEVAL]: ParkingRequestTypeIdConstant.RETRIEVAL,
  [ParkingRequestTypeConstant.BOOKING]: ParkingRequestTypeIdConstant.BOOKING,
  [ParkingRequestTypeConstant.CANCEL_STORAGE]: ParkingRequestTypeIdConstant.CANCEL_STORAGE,
  [ParkingRequestTypeConstant.CANCEL_RETRIEVAL]: ParkingRequestTypeIdConstant.CANCEL_RETRIEVAL,
  [ParkingRequestTypeConstant.CANCEL_BOOKING]: ParkingRequestTypeIdConstant.CANCEL_BOOKING
};

export enum RequestAckIdConstants {
  ACCEPTED = 1,
  REQUEST_ACCEPTED_FLOOR_NOT_HEALTHY = 9,
  REQUEST_SKIPPED_OLD_ENTRY = 5000,
  REQUEST_CANCELLED_SCHEDULE_CANCELLED_BY_USER = 5001,
  REQUEST_CANCELLED_NO_CONFIRMATION_FROM_USER = 5002,
  REQUEST_CANCELLED_ACK_NOT_RECEIVED = 5003,
  REQUEST_STATUS_NOT_FOUND_PERFORMED_PARKING_MAP_RESYNC = 5004
}

export enum RequestStatus {
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  REJECTED = "REJECTED",
  REQUEST_SENT = "REQUEST SENT",
  CANCELLATION_REQUEST_SENT = "CANCELLATION REQUEST SENT",
  REQUEST_ACK_RECEIVED = "REQUEST ACK RECEIVED",
  CANCELLATION_REQUEST_ACK_RECEIVED = "CANCELLATION REQUEST ACK RECEIVED",
  UNABLE_TO_IDENTIFY = "UNABLE TO IDENTIFY"
}

export enum LogParkingRequestTypeIdConstant {
  REQUEST_RAISED = 1,
  CANCEL_REQUEST_RAISED = 2,
  REQUEST_FULFILLED = 3
}

export enum NotificationTypeConstants {
  CORE_MODULE = "CORE_MODULE",
  MAINTENANCE = "MAINTENANCE",
  OTHER = "OTHER"
}

export enum GWStatusConstants {
  CONNECTED = 1,
  DISCONNECTED = 0
}

export enum PLCStatusConstants {
  CONNECTED = 1,
  DISCONNECTED = 0,
  GW_INACTIVE = 2
}

export const HMI_ENTRY = "HMI";

export enum SyncDirectionConstants {
  CLOUD_TO_DEVICE = "C2D",
  DEVICE_TO_CLOUD = "D2C"
}
